import getters from './getters'
import mutations from './mutations'

const state = {
  isModalOpen: false
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
